<template>
    <div class="editable-list-wrapper">
        <Header v-if="showHeader" :isSelected="!current" :title="title" @headerClick="handleHeaderClick">
            <slot></slot>
        </Header>
        <div class="item-list scroll-tracker">
            <div class="item-list-panel">
                <Item
                    v-for="item in sourceData"
                    :key="item.id"
                    :data="item"
                    :editable="editable"
                    :isSelected="item.id === current"
                    :actionTypes="actionTypes"
                    @selectItem="selectItemHandler"
                    @operatorClick="itemOprClick"
                    @transferEnd="itemTransferEnd"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Header from "./header";
import Item from "./item";

const DEFAULT_ACTION_TYPES = ["add", "edit", "delete", "move"];

export default {
    name: "EditableList",
    components: {
        Header,
        Item
    },
    props: {
        dataSource: {
            type: Array,
            default: () => {
                return [];
            }
        },
        editable: {
            type: Boolean,
            default: true
        },
        actionTypes: {
            type: Array,
            default: () => {
                return DEFAULT_ACTION_TYPES;
            }
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ""
        },
        currentSelected: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    },
    computed: {
        sourceData() {
            return this.dataSource;
        },
        current() {
            return this.currentSelected;
        }
    },
    methods: {
        selectItemHandler(data) {
            this.$emit("itemSelected", data);
        },
        itemOprClick(data) {
            if (data.actionType === "delete" || data.actionType === "add") {
                this.$emit("itemOperate", data);
            } else if (data.actionType === "edit") {
                this.editOperator(data);
            }
        },
        editOperator(data) {
            if (data.record.isChanged && data.record.newLabel) {
                this.$emit("itemOperate", data);
            }
        },
        itemTransferEnd(data) {
            data.opr = "transfer";
            this.$emit("itemOperate", data);
        },
        handleHeaderClick() {
            this.$emit("headerSelected");
        }
    }
};
</script>

<style lang="scss" scoped>
.editable-list-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;

    .item-list {
        overflow-x: hidden;
        overflow-y: auto;
        flex-shrink: 1;
        flex-grow: 1;
    }

    .item-list-panel {
        padding-top: 1px;
        margin-top: -1px;
        position: relative;
    }
}
</style>
